module.exports = __webpack_public_path__ + "static/media/voice7.4e75a40.wav";


//////////////////
// WEBPACK FOOTER
// ./src/components/voice/voice7.wav
// module id = byON
// module chunks = 1